// Write Actions Using the Flux Standard Action Convention
// https://redux.js.org/style-guide/style-guide#write-actions-using-the-flux-standard-action-convention

export const standardAction = (type, payload, meta = null) => ({
  type,
  payload,
  isError: false,
  meta,
});

export const errorAction = (type, payload, meta = null) => ({
  type,
  payload,
  isError: true,
  meta,
});
